/**
 * StatWidgetsSection — grid of numeric stat cards with icons.
 */

export default function StatWidgetsSection({ config, theme }) {
  const widgets = config?.widgets || [];

  if (widgets.length === 0) return null;

  return (
    <div className="row g-3">
      {widgets.map(w => (
        <div key={w.id} className="col-6 col-md-3">
          <div
            className="rounded p-3 text-center h-100"
            style={{
              background: '#fff',
              border: `2px solid var(--primary-color)`,
              borderRadius: 'var(--card-radius, 12px)',
            }}
          >
            <i
              className={`bi ${w.icon || 'bi-bar-chart'}`}
              style={{ fontSize: 28, color: 'var(--primary-color)' }}
            />
            <div
              style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--primary-color)', lineHeight: 1.1, marginTop: 6 }}
            >
              {w.value}
            </div>
            <div className="text-muted small mt-1">{w.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
